import { useState, FunctionComponent, useEffect } from "react";
import { ReactComponent as EditIcon } from "../../../assets/edit-filled.svg";
import { AddNoteModal } from "src/components/generic/Modal";
import { dynamo, types } from "src/utils";
import SquareTile from "src/components/generic/tiles/SquareTile";
import MAPReportViewer from "src/components/cbc/MAPReportViewer";

interface IClientNotesProps {
  client: types.userTypes.Client;
}

const ClientNotes: FunctionComponent<IClientNotesProps> = ({ client }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [map, setMap] = useState<Record<any, any> | null>(null);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const fetchMap = async () => {
    try {
      const mapNote = client?.notes?.filter((note) =>
        note.text.includes("MAP stored with ID:")
      )[0];
      const mapId = mapNote?.text?.split(": ")[1];

      console.log({ mapNote, mapId });

      if (mapId) {
        const fetchMap = await dynamo.fetch.mapById(mapId);

        console.log({ fetchMap });
        setMap(fetchMap);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (!map) fetchMap();
  }, []);
  console.log({ map });
  return (
    <SquareTile>
      <div className="flex justify-between w-full border-primary border-bottom mb-4">
        <h1 className="text-2xl">Notes</h1>
        <p className="mt-2">
          <EditIcon
            height={25}
            width={25}
            onClick={toggleModal}
            className="cursor-pointer"
            data-testid="edit-client-icon"
          />
        </p>
      </div>

      {map && (
        <div>
          <div className="flex justify-between items-center mb-8">
            {map.scoreCards?.map((card: any) => (
              <a href={card?.link} target="_blank">
                <p className="font-bold text-primary">
                  View Report (Score: {card?.score})
                </p>
              </a>
            ))}
          </div>
          <MAPReportViewer
            client={client}
            reportASummary={map.reportASummary}
            reportBSummary={map.reportBSummary}
            reportCSummary={map.reportCSummary}
            pastDue={typeof map.pastDue === "number" ? map.pastDue : -1}
            riskReport={map.riskReport || {}}
            creditReportType={map.creditReportType}
            scoreCards={map?.scoreCards}
          />
        </div>
      )}

      <div className="flex  flex-col justify-center gap-4">
        {client?.notes && client?.notes?.length > 0 ? (
          client.notes.map((note) => (
            <p key={note.id} className="text-lg mb-2">
              <span className="font-medium">
                {note.author?.name}{" "}
                {note?.date?.toLocaleString()?.split("T")[0]}
              </span>
              : {note.text}
            </p>
          ))
        ) : (
          <p className="flex justify-center pt-[10%]">No Notes on File</p>
        )}
      </div>

      <AddNoteModal
        client={client}
        open={isModalOpen}
        toggleModal={toggleModal}
      />
    </SquareTile>
  );
};

export default ClientNotes;
